"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const usePwa_1 = __importDefault(require("./usePwa"));
const utils_1 = require("./../utils");
;
const defaultOptions = { fixed: false };
const usePwaAppSize = (width = 800, height = 800, options = defaultOptions) => {
    const { isStandalone } = usePwa_1.default();
    react_1.useEffect(() => {
        if (utils_1.isServer()) {
            return;
        }
        const resizeWindow = () => window.resizeTo(width, height);
        if (isStandalone) {
            window.addEventListener('load', resizeWindow);
            if (options.fixed) {
                window.addEventListener('resize', resizeWindow);
            }
        }
        return () => {
            window.removeEventListener('load', resizeWindow);
            if (options.fixed) {
                window.removeEventListener('resize', resizeWindow);
            }
        };
    }, [isStandalone]);
};
exports.default = usePwaAppSize;
